import React from 'react'
import PropTypes from 'prop-types'
import { renderRawHack } from '../Utilities/RichTextRenderer'

function LegalStatementV3({ fields }) {
  return (
    <p className="disclaimer-text" key={fields.id}>
      {renderRawHack(fields.statement)}
    </p>
  )
}

LegalStatementV3.propTypes = {
  fields: PropTypes.object.isRequired
}

export { query as data } from './LegalStatementQuery'

export default LegalStatementV3
